import Auth from '../services/auth';
import axios from 'axios';
import { API_ROOT } from './apiConfig';

const auth = new Auth();
 

export const getWorkTypesByAccountNumber = async (accountNumber) => {
    const config = {
        headers: {
            "Authorization": `Bearer ${auth.getToken()}`
        }
    }
    return await axios.get(`${API_ROOT}/api/v1/Transcriptions/GetWorkTypesSNChart?AccountNumber=${accountNumber}`, config);
}


// WEBPACK FOOTER //
// ./src/services/workTypeService.js